import router from '@/router'

const goTo = (path) => {
  router.push({path})
}

export default {
  goToVerification () {
    goTo('/verification')
  },
  goToHome () {
    goTo('/')
  },
  goToPrintLabels () {
    goTo('/print-labels')
  },
  goToPrintReturnAddress () {
    goTo('/print-return-address')
  },
  goToPageToPrint () {
    goTo('/page-to-print')
  },
  goToChanges () {
    goTo('/changes')
  },
  goToDeliveries (query) {
    if (query != null && typeof query === 'object' && Object.keys(query).length) {
      router.push({ path: '/deliveries', query })
      return
    }
    goTo('/deliveries')
  },
  goToRefunds (query) {
    if (query != null && typeof query === 'object' && Object.keys(query).length) {
      router.push({ path: '/refunds', query })
      return
    }
    goTo('/refunds')
  }
}



//////////////////
// WEBPACK FOOTER
// ./my_modules/router/index.js
// module id = null
// module chunks = 